export const Dictionary = {

    /**
     * 版本号
     */
    VERSION: 'version'
}